// extracted by mini-css-extract-plugin
module.exports = {"aside":"aside_aside_2AqTZ","logo":"aside_logo_1AtKb","text":"aside_text_ckcZg"};